import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class BollardAxisBerths extends PureComponent {
  static propTypes = {
    berths: PropTypes.array,
    bollardToScreen: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className="berths">
        {this.props.berths &&
          this.props.berths.map((berth, index) => {
            const berthStartX = this.props.bollardToScreen(berth.startBollard)
            const berthEndX = this.props.bollardToScreen(berth.endBollard)

            const style = {
              left: berthStartX || 0,
              width: berthEndX - berthStartX || 0
            }

            return (
              <div key={index} className="berth" style={style}>
                <span>{berth.terminalName}</span>
              </div>
            )
          })}
      </div>
    )
  }
}
